import * as React from "react";
import type { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeWidth={2}
      d="M11.333 2.276a.943.943 0 0 1 1.334 0l2.691 2.691a.943.943 0 0 1 0 1.334l-2.69 2.691a.943.943 0 0 1-1.335 0l-2.691-2.69a.943.943 0 0 1 0-1.335zM17.699 8.642a.943.943 0 0 1 1.334 0l2.69 2.69a.943.943 0 0 1 0 1.335l-2.69 2.691a.943.943 0 0 1-1.335 0l-2.69-2.69a.943.943 0 0 1 0-1.335zM4.967 8.642a.943.943 0 0 1 1.334 0l2.691 2.69a.943.943 0 0 1 0 1.335l-2.69 2.691a.943.943 0 0 1-1.335 0l-2.69-2.69a.943.943 0 0 1 0-1.335zM11.333 15.008a.943.943 0 0 1 1.334 0l2.691 2.69a.943.943 0 0 1 0 1.335l-2.69 2.69a.943.943 0 0 1-1.335 0l-2.691-2.69a.943.943 0 0 1 0-1.335z"
    />
  </svg>
);
export default SvgComponent;
